/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumTagSemanticoDTOElementoRicerca =
  (typeof EnumTagSemanticoDTOElementoRicerca)[keyof typeof EnumTagSemanticoDTOElementoRicerca];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumTagSemanticoDTOElementoRicerca = {
  RICERCA_LIBERA: 'RICERCA_LIBERA',
  RICERCA_PER_INTERVALLO: 'RICERCA_PER_INTERVALLO',
  RICERCA_CON_MENU_TENDINA: 'RICERCA_CON_MENU_TENDINA',
} as const;
